import { ChangeDetectorRef, Component } from "@angular/core";
import { BaseListComponent } from "projects/sepidz-web-framework-shell/src/lib/shared/controls/base/base-list.component";
import { SelectorService } from "projects/sepidz-web-framework-shell/src/lib/shared/controls/base/selector.service";
import { SplashFormService } from "projects/sepidz-web-framework-shell/src/lib/shared/splash-form/Splash-form.service";
import { TabularService } from "projects/sepidz-web-framework-shell/src/lib/tabular/tabular.service ";
import { EntityListAction, Permission } from "projects/sepidz-web-framework/src/lib/models";
import { DialogType } from "projects/sepidz-web-framework/src/lib/models/dialog.enum";
import { GridFilter, Utilities } from "projects/sepidz-web-framework/src/lib/services";
import { Subject, Subscription } from "rxjs";
import { filter, takeUntil } from "rxjs/operators";
import { ConfirmDateValue } from "src/app/frontoffice/dateDialog/dateDialog.component";
import { CashierSettlementModel } from "../../model/usersettlement.model";
import { CashierSettlementFormComponent } from "../cashiersettlement-form/cashiersettlement-form.component";

@Component({
  selector: "ngx-casheirsettlement-list.component",
  templateUrl: "./cashiersettlement-list.component.html",
  styleUrls: ["./casheirsettlement-list.component.scss"],
})
export class CasheirSettlementListComponent extends BaseListComponent {
  actions: EntityListAction[];
  unSortableFilterable: string[] = [];
  filters: GridFilter[] = [
    {
      Filed: "Code",
      Value: 0,
      Skip: 0,
      Take: 0,
      Operator: "desc",
      Type: "S",
    },
  ];
  cashierSettlement: CashierSettlementModel;
  constructor(
    private _tabsservice: TabularService,
    private splashFormService: SplashFormService,
    private selectorService: SelectorService,
    public cd: ChangeDetectorRef
  ) {
    super();
    this.inputEditorform = CashierSettlementFormComponent;
    this.onActionClick = this.onActionClick.bind(this);
  }
  ngOnInit() {
    this.apiName = "CashierSettlemet";
    this.areaName = "RestaurantSale";
    this.label = this.translate("ClientApp.FrontOffice.Financial.CashierSettlement.ReceiveFromCashier");
    const currentInformation = this.accountService.authService.currentInformation();
    if (
      (currentInformation.BranchingAdvancedEnabled || currentInformation.BranchingLightEnabled || currentInformation.RestaurantCallCenter) &&
      !this.accountService.authService.currentBranch?.AccessToAllBranches
    ) {
      this.filters.push({
        Filed: "BranchId",
        Value: this.accountService.authService.currentBranchId,
        Skip: 0,
        Take: 0,
        Operator: "eq",
        Type: "F",
      });
    }
    this.setactions();
    const columnsToExclude = ["TotalReceipt", "NewRemainValue"];

    this.unSortableFilterable.push(...columnsToExclude);
  }
  createAccVoucher(gridFilter: GridFilter[] | ConfirmDateValue, apiName: string, closeDialog?: Function, subscription?: Subscription) {
    this.splashFormService.openDialog("", this.translate("ClientApp.FrontOffice.Financial.CashierSettlement.AccountingDocumentIssued"));
    this.httpCommonService
      .create(this.apiName + "/" + apiName, gridFilter)
      .pipe(takeUntil(this.ngUnsubscribe))
      .subscribe(
        (x) => {
          this.splashFormService.closeLoading();
          this._tabsservice.tabItemonRefreshData.next(this.apiName);
          this.sts.showDialog(this.translate("ClientApp.FrontOffice.Financial.CashierSettlement.DocumentsIssuedSuccessfully"), "");
          if (closeDialog) closeDialog();
          subscription.unsubscribe();
        },
        (error) => {
          this.splashFormService.closeLoading();
          this.sts.showDialog(
            `${this.translate("ClientApp.FrontOffice.Financial.CashierSettlement.ErrorIssuingDocuments")}:${Utilities.getHttpResponseMessage(error)}`,
            this.translate("ClientApp.FrontOffice.Financial.CashierSettlement.Error")
          );
          if (closeDialog) this.selectorService.submitted$.next(false);
        }
      );
  }
  deleteAccVoucher(gridFilter: GridFilter[], apiName: string) {
    this.splashFormService.openDialog("", this.translate("ClientApp.FrontOffice.Financial.CashierSettlement.DeletingAccountingDocument"));
    this.httpCommonService
      .create(this.apiName + "/" + apiName, gridFilter)
      .pipe(takeUntil(this.ngUnsubscribe))
      .subscribe(
        (x) => {
          this.splashFormService.closeLoading();
          this._tabsservice.tabItemonRefreshData.next(this.apiName);
          this.sts.showDialog(this.translate("ClientApp.FrontOffice.Financial.CashierSettlement.DocumentsDeletedSuccessfully"), "");
        },
        (error) => {
          this.splashFormService.closeLoading();
          this.sts.showDialog(
            `${this.translate("ClientApp.FrontOffice.Financial.CashierSettlement.ErrorDeletingDocuments")}:${Utilities.getHttpResponseMessage(
              error
            )}`,
            this.translate("ClientApp.FrontOffice.Financial.CashierSettlement.Error")
          );
        }
      );
  }
  onActionClick(action: EntityListAction, onRowSelected: CashierSettlementModel, onRowsSelected: CashierSettlementModel[], gridFilter: GridFilter[]) {
    if (onRowSelected && (!onRowsSelected || onRowsSelected.length <= 0)) onRowsSelected = [onRowSelected];
    let CasheirSettlementIds: number[] = [];
    ///صدور اسناد
    if (
      action.name === "CreateAccVoucher" ||
      action.name === "DeleteAccVoucher" ||
      action.name === "CreateTrsVoucher" ||
      action.name === "DeleteTrsVoucher"
    ) {
      if (onRowSelected) CasheirSettlementIds.push(onRowSelected.Id);
      if (onRowsSelected && onRowsSelected.length > 0) {
        onRowsSelected.forEach((x) => {
          if (x && x.Id) CasheirSettlementIds.push(x.Id);
        });
      }
      if (CasheirSettlementIds && CasheirSettlementIds.length > 0)
        gridFilter.push({
          Type: "F",
          Filed: "CasheirSettlementIds",
          Value: CasheirSettlementIds,
          Logic: "and",
          Operator: "eq",
          Skip: 0,
          Take: 0,
        });

      if (action.name === "CreateAccVoucher") {
        if (gridFilter.length <= 0) {
          this.sts.showDialog(
            this.translate("ClientApp.FrontOffice.Financial.CashierSettlement.UnselectedOrSelectedDocumentsAccountingDocuments"),
            this.translate("ClientApp.FrontOffice.Financial.CashierSettlement.Error")
          );
          return;
        }
        const confirmValue: Subject<ConfirmDateValue> = new Subject();
        const subscription = confirmValue.pipe(filter((x) => !!x)).subscribe((value) => {
          value["FiscalYearId"] = this.accountService.authService.currentFiscalYear.Id;
          this.sts.showDialog(
            this.translate("ClientApp.FrontOffice.Financial.CashierSettlement.HasIssuingAcountingDocument"),
            this.translate("ClientApp.FrontOffice.Financial.CashierSettlement.IssuanceDocument"),
            DialogType.confirm,
            () => this.createAccVoucher(value, "CreateAccountingVoucher", value.closeDialog, subscription),
            () => this.selectorService.submitted$.next(false)
          );
        });
      }
      if (action.name === "CreateTrsVoucher") {
        if (gridFilter.length <= 0) {
          this.sts.showDialog(
            this.translate("ClientApp.FrontOffice.Financial.CashierSettlement.UnselectedOrSelectedDocumentsIssuedReceiptAndPaymentDocuments"),
            this.translate("ClientApp.FrontOffice.Financial.CashierSettlement.Error")
          );
          return;
        }
        this.sts.showDialog(
          this.translate("ClientApp.FrontOffice.Financial.CashierSettlement.HasIssuanceReceiptAndPaymentDocument"),
          this.translate("ClientApp.FrontOffice.Financial.CashierSettlement.IssuanceDocument"),
          DialogType.confirm,
          () => this.createAccVoucher(gridFilter, action.name)
        );
      }
      if (action.name === "DeleteAccVoucher") {
        if (gridFilter.length <= 0) {
          this.sts.showDialog(
            this.translate("ClientApp.FrontOffice.Financial.CashierSettlement.UnselectedOrSelectedDocumentsDeleted"),
            this.translate("ClientApp.FrontOffice.Financial.CashierSettlement.Error")
          );
          return;
        }
        this.sts.showDialog(
          this.translate("ClientApp.FrontOffice.Financial.CashierSettlement.HasDeleteAccountingDocument"),
          this.translate("ClientApp.FrontOffice.Financial.CashierSettlement.DeleteDocument"),
          DialogType.confirm,
          () => this.deleteAccVoucher(gridFilter, action.name)
        );
      }
      if (action.name === "DeleteTrsVoucher") {
        if (gridFilter.length <= 0) {
          this.sts.showDialog(
            this.translate("ClientApp.FrontOffice.Financial.CashierSettlement.UnselectedOrSelectedDocumentsDeleted"),
            this.translate("ClientApp.FrontOffice.Financial.CashierSettlement.Error")
          );
          return;
        }
        this.sts.showDialog(
          this.translate("ClientApp.FrontOffice.Financial.CashierSettlement.HasDeleteReceiptAndPaymentDocument"),
          this.translate("ClientApp.FrontOffice.Financial.CashierSettlement.DeleteDocument"),
          DialogType.confirm,
          () => this.deleteAccVoucher(gridFilter, action.name)
        );
      }
    }
    return;
  }
  fillData() {}
  setactions() {
    this.actions = [
      {
        name: "CreateTrsVoucher",
        disabled: false,
        displayName: this.translate("ClientApp.FrontOffice.Financial.CashierSettlement.ReceiptAndPaymentDocument"),
        iconName: "icon-payments-o",
        apiName: "CashierSettlemet/CreateTrsVoucher",
        areaName: this.areaName,
        permission: Permission.samePermission,
      },
      {
        name: "DeleteTRsVoucher",
        disabled: false,
        displayName: this.translate("ClientApp.FrontOffice.Financial.CashierSettlement.RemoveReceiptAndPaymentDocument"),
        iconName: "icon-star_border-o",
        apiName: "RestaurantSale/DeleteTrsVoucher",
        areaName: this.areaName,
        permission: Permission.samePermission,
      },
    ];
  }

  onRowSelected(cashier: CashierSettlementModel) {
    if (cashier.Id != null) {
      if (cashier.AccFixNo != null && cashier.AccVoucherId != null && !this.actions.some((x) => x.name == "DeleteAccVoucher")) {
        this.actions.push({
          name: "DeleteAccVoucher",
          disabled: false,
          displayName: this.translate("ClientApp.FrontOffice.Financial.CashierSettlement.DeleteAccountingDocument"),
          iconName: "icon-canceldocument",
          apiName: "CashierSettlemet/DeleteAccVoucher",
          areaName: this.areaName,
          permission: Permission.samePermission,
        });
        this.actions = [...[], ...this.actions];
      }
      console.log(this.actions);

      this.cd.markForCheck();
    } else {
      var index = this.actions.findIndex((x) => x.name == "DeleteAccVoucher");
      if (index > -1) this.actions.splice(index, 1);
    }
  }
}
